var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.service.serviceName))]),_c('td',{staticClass:"td-status"},[_c('img',{staticClass:"status-symbol",attrs:{"src":_vm.statusIcon,"width":"28","height":"28"}})]),_c('td',[_vm._v(_vm._s(_vm.service.output))])])
}
var staticRenderFns = []

export { render, staticRenderFns }